export default __webpack_public_path__ + "static/media/mail.960945b6.svg";